import React from "react";

export default function ErkendeClubsGemeenteIcon() {
    return (<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="1.5rem" y="1.5rem" height="1.8rem"
             viewBox="0 0 425.2 425.2" enableBackground="new 0 0 425.2 425.2" xmlSpace="preserve">
        <g id="Laag_1">
            <circle fill="#39B4E8" cx="217.7" cy="211.7" r="182.2"/>
        </g>
        <g id="Laag_2">
            <g>
                <path fill="#FFFFFF" d="M92.4,281.7c-41-73-16.4-157.5,53.1-196.6c45.1-25.4,86.3-25.1,124.4-6.8l-17.5,37.6
                    c-28.6-13.1-55.9-13-88.1,5.1c-48.4,27.2-61.5,86.1-32.1,138.4c30,53.4,87.2,71.4,136.3,43.8c31.5-17.7,48.1-42.8,52.9-77l41.4,4
                    c-6.1,47.9-28.6,82.5-75.9,109.1C217.3,378.2,133.4,354.7,92.4,281.7z"/>
            </g>
            <line fill="none" stroke="#FFFFFF" strokeWidth="24" strokeMiterlimit="10" x1="154.8" y1="250.7" x2="264.4" y2="187.5"/>
        </g>
        </svg>
    );
}
